import { Directive, ElementRef, HostListener, Renderer2, Input } from '@angular/core';

@Directive({
  selector: '[appTooltip]'
})
export class TooltipDirective {
  @Input('appTooltip') tooltipText = ''; // Get tooltip text from attribute
  tooltip: HTMLElement | null = null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.tooltip) {
      this.tooltip = this.renderer.createElement('span');
      this.tooltip.innerText = this.tooltipText;
      this.renderer.appendChild(document.body, this.tooltip);
      this.renderer.setStyle(this.tooltip, 'position', 'fixed');
      this.renderer.setStyle(this.tooltip, 'background', 'black');
      this.renderer.setStyle(this.tooltip, 'color', 'white');
      this.renderer.setStyle(this.tooltip, 'padding', '5px 10px');
      this.renderer.setStyle(this.tooltip, 'border-radius', '4px');
      this.renderer.setStyle(this.tooltip, 'font-size', '12px');
      this.renderer.setStyle(this.tooltip, 'white-space', 'nowrap');
      this.renderer.setStyle(this.tooltip, 'z-index', '1000');
      this.renderer.setStyle(this.tooltip, 'pointer-events', 'none'); // Prevents tooltip from interfering with elements
    }

    // Position tooltip near cursor
    this.renderer.setStyle(this.tooltip, 'left', `${event.pageX + 10}px`);
    this.renderer.setStyle(this.tooltip, 'top', `${event.pageY + 10}px`);
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (this.tooltip) {
      this.renderer.removeChild(document.body, this.tooltip);
      this.tooltip = null;
    }
  }
}
